import React from "react";
import { useKarateUi } from "@/hooks/useKarateUi.js";

const VARIANT_KEY = {
  demoLocalAwaiting: "demoLocalAwaiting",
  managerPrepared: "managerPrepared",
  userPrepared: "userPrepared",
  backendConnected: "backendConnected",
};

/**
 * Badge FR/EN — zone backend, démo/local ou préparation espace.
 */
export function BackendZoneBadge({ variant = "demoLocalAwaiting", testId = "backend-zone-badge" }) {
  const { ui } = useKarateUi();
  const key = VARIANT_KEY[variant] || "demoLocalAwaiting";
  const msg = ui.backendStaging[key];

  return (
    <p className={`backend-zone-badge backend-zone-badge--${variant}`} data-testid={testId} data-variant={variant} role="status">
      {msg}
    </p>
  );
}

/**
 * Badge selon source données hybride (backend vs local).
 */
export function HybridDataStatusBadge({ dataSource, backendStatus, testId = "hybrid-data-status-badge" }) {
  const { ui } = useKarateUi();

  if (dataSource === "backend" && backendStatus === "backend") {
    return <BackendZoneBadge variant="backendConnected" testId={testId} />;
  }
  if (backendStatus === "loading") {
    return (
      <p className="backend-zone-badge backend-zone-badge--loading" data-testid={testId} role="status">
        {ui.backendStaging.loading}
      </p>
    );
  }
  return <BackendZoneBadge variant="demoLocalAwaiting" testId={testId} />;
}
